/*
 * @Author: wsx
 * @Date: 2022-01-21 12:20:32
 * @LastEditTime: 2022-01-21 15:21:28
 * @LastEditors: your name
 * @Description: 常量
 */
export const CLIENT_KEY = "video.client";
export const CLIENT_CAMERA = "video.client";
